var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "watermark-container" },
    _vm._l(_vm.watermarks, function (item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "watermark-text",
          style: {
            width: `${_vm.itemSize.w}px`,
            height: `${_vm.itemSize.h}px`,
          },
        },
        [
          _vm.config.showIndex.includes(index)
            ? _c("div", { staticClass: "watermark-rotate" }, [
                _vm._v(_vm._s(_vm.text)),
              ])
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }